<!--
    调研管理
-->
<template>
    <div class="page">
        <!--<h3 class="page-title">调研管理</h3>-->
        <el-form class="page-query" :inline="true" size="mini">
            <el-form-item :label="$t('survey.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('c.name')"
                          @keyup.enter.native="query(1)" clearable></el-input>
                <!-- 防止只有一个文本输入框按enter键表单自动提交-->
                <el-input type="text" name="notautosubmit" style="display:none"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>
        <div class="page-table">
            <div class="page-operate">
                <el-button-group style="width: 100%">
                    <el-tooltip class="item" effect="dark" :content="$t('survey.add')" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="surveyPaper()">
                            <i class="nucfont inuc-add"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip v-if="surveySelectedArr.length>0" class="item" effect="dark" :content="$t('c.delete')"
                                placement="top-start" :hide-after="1000" style="float: right">
                        <el-button type="danger" size="small" @click="deleteSurveyPaper">
                            <i class="el-icon-delete" style="font-size: 16px"></i>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>
            <data-tables class="form-table"
                         ref="survey"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         header-align="center"
                         @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="100px" align="center"
                                 :selectable='checkboxInit'></el-table-column>
                <el-table-column v-for="(title,index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 sortable="custom"
                                 show-overflow-tooltip
                                 align="center"
                                 class="table-title">
                </el-table-column>
                <el-table-column :label="$t('c.operation')" align="center" width="150">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview"
                           :title="$t('c.view')"
                           @click="viewSurveyPaper(scope.row.id)"></i>
                        <i class="nucfont inuc-edit operate-edit"
                           v-if=" userInfo.userID==scope.row.creatorID"
                           :title="$t('c.edit')"
                           @click="surveyPaper(scope.row.id)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>

        <!--查看调研问卷-->
        <view-survey-paper v-if="isViewSurveyPaper"
                           :surveyPropData="surveyPropData"
                           :surveyPropInfo="surveyPropInfo"
                           @close="closeSurvey"></view-survey-paper>
    </div>
</template>

<script>
    import api from '@/api';
    import {screenfull, Ticket} from '@/utils';
    import ViewSurveyPaper from './ViewSurveyPaper';

    export default {
        data() {
            return {
                formSearch: {
                    name: undefined,
                },
                // 表格信息开始
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('survey.name'),
                    }, {
                        prop: 'createTime',
                        label: this.$t('c.creationTime')
                    }, {
                        prop: 'creatorName',
                        label: this.$t('c.creator')
                    }
                ],
                // 表格信息结束
                surveySelectedArr: [],
                isViewSurveyPaper: false,
                surveyPropData: undefined,
                surveyPropInfo: undefined
            }
        },
        created() {
            this.query();
        },
        computed: {
            userInfo() {
                return Ticket.get() || {}
            }
        },
        methods: {
            query(page) {
                if (page)  {
                    this.currentPage = page;
                }
                let data = this.formSearch;
                api.getSurveyList(data).then(res => {
                    if (res.package) {
                        this.tableData = res.package
                    }
                })
            },
            surveyPaper(id) {
                if (id) {
                    // 编辑
                    this.$router.push({name: 'editSurveyPaper', params: {id: id}});
                } else {
                    // 添加
                    this.$router.push({name: 'addSurveyPaper'});
                }
            },
            viewSurveyPaper(id) {// 查看
                screenfull.request();
                this.isViewSurveyPaper = true;
                api.getSurveyTemplate(id).then(res => {
                    if (res.package) {
                        this.surveyPropData = res.package.items;
                        this.surveyPropInfo = res.package
                    }
                })
            },
            closeSurvey() {
                this.isViewSurveyPaper = false;
            },
            // 以下关于多选框
            selectionChange(val) {
                let arr = [];
                if (val.length > 0) {
                    val.forEach(ele => {
                        arr.push(ele.id)
                    })
                } else {
                    arr = []
                }
                this.surveySelectedArr = arr;
            },
            checkboxInit(row) {// 控制表格多选框可选状态
                return  (row.creatorID === this.userInfo.userID);
            },
            // 删除问卷
            deleteSurveyPaper() {
                let _this = this;
                let data = {
                    ids: this.surveySelectedArr
                };

                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteSurveyPaper(data).then(res => {
                        _this.$message.success(this.$t('m.delSuccess'));
                        _this.query();
                    })
                }).catch(()=>{});
            },

            onSubpageClose() {
                if (Ticket.get()) this.query()
            }
        },
        watch: {},
        components: {
            ViewSurveyPaper
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';
</style>
